import styled from 'styled-components'
import {
  RadioButtonContainer,
} from '@/components/controls/RadioButton/styles'
import LabelWithIcon from '@/components/blocks/LabelWithIcon/styles'

export const CatalogContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const InfoField = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 1.4rem;
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.colors.redisign.default};
  text-transform: uppercase;
`
export const InfoContainer = styled.div`
  padding: 10px 0px;
`

export const IconContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${({ type, theme }) => type && `
    svg,
    .svgFill {
      height: 14px;
      width: 14px;
      margin-right: 10px;
      fill: ${theme.colors.colors.redisign.dark};
    }
  `}
`

export const CustomFieldContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.backgrounds.default};
  padding: 10px;
  padding-top: 20px;
  margin: 5px 0px;
  box-shadow: 0px 10px 23px rgba(0, 0, 0, 0.12);
  border: 1px solid ${({ theme }) => theme.colors.backgrounds.default};
  background: ${({ theme }) => theme.colors.backgrounds.redisign.table.dark};
  ${IconContainer} { 
    height: auto;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  && > div:last-child {
    padding-top: 10px;
  }
  ${({ remove, theme }) => remove && `
    height: 44px;
    padding: 0px 10px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${theme.colors.colors.default};
    background: ${({ theme }) => theme.colors.backgrounds.default};
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    cursor: pointer;
    && > div:last-child {
      padding-top: 0px;
    }
  `}
`

export const CustomFieldBlock = styled.div`
  width: 100%;
`

export const CancelButton = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.backgrounds.green};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors.backgrounds.green};
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.4rem;
  height: 25px;
  padding: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CatalogRow = styled.div`
  flex: 1;
  width: 100%;  
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};
`

export const CatalogTitle = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.colors.redisign.default};
  text-transform: uppercase;
  padding-left: 10px;
  text-align: left;
`
export const ToggleContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  svg {
      transform-origin: center;
      transform: rotate(180deg);
  }
  ${({ isOpen }) => isOpen && `
    svg {
      transform-origin: center;
      transform: rotate(0deg);
    }
  `}
`
export const CatalogOptionsContainer = styled.div`
  width: 100%;
  padding: 10px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};


`
export const ButtonContainer = styled.div`
  padding: 20px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .svgFill {
    height: 16px;
    fill: ${({ theme }) => theme.colors.white};
  }
  svg {
    margin-right: 10px;
  }
  color: ${({ theme }) => theme.colors.colors.redisign.default};
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1.4rem;
`

export const InputAndLabelContainer = styled.div`
  padding: 5px 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  && > div {
    text-align: left;
  }
  input {
    width: 100%;
    height: 28px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 1.2rem;
    line-height: 1.4rem;
  }
  ${({ row }) => row && `
    justify-content: space-between;
    flex-direction: row;
  `}
  ${RadioButtonContainer} {
    padding: 5px 0px;
  }
  & > span {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: green;
  }
  ${LabelWithIcon} {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: ${({ theme }) => theme.colors.colors.redisign.default};
    margin-bottom: 5px;
  }

`
